import { useCallback } from 'react';
import type { GoodsOption } from 'shared/src/api';
import { useProductCheckout } from '../queries/useProductCheckout';
import { useLogClickCheckOut } from './useLogClickCheckOut';
import { useMyInfo } from 'shared/src/queries';
import { useOpenDeeplink } from 'shared/src/hooks';

export const useOnPressPurchase = ({
  selected,
  onCompletePurchase,
  onAnonymouseUserPressedPurchase,
}: {
  selected: GoodsOption[];
  onCompletePurchase: () => void;
  onAnonymouseUserPressedPurchase: () => void;
}) => {
  const { mutateAsync: checkoutProduct, isPending: loadingProductCheckout } =
    useProductCheckout(selected);
  const { data: myInfo } = useMyInfo();
  const logClickCheckOut = useLogClickCheckOut({ selected });
  const { openDeeplink } = useOpenDeeplink();

  const onPressPurchase = useCallback(async () => {
    if (myInfo?.is_anonymous) {
      onAnonymouseUserPressedPurchase();
      return;
    }
    logClickCheckOut();
    const result = await checkoutProduct();

    if (result) {
      openDeeplink(result.deeplink);
      onCompletePurchase();
    }
  }, [
    checkoutProduct,
    logClickCheckOut,
    myInfo?.is_anonymous,
    onAnonymouseUserPressedPurchase,
    onCompletePurchase,
    openDeeplink,
  ]);

  return { onPressPurchase, loadingProductCheckout };
};